module.exports = __webpack_public_path__ + "static/frameSmall-b41df0c38dcd97a81277aaa29f960ec4.png";